import type { SchedulingCandidate } from "../../api/statelessClient";
import { CandidateTimetablePreview } from "./CandidateTimetablePreview";

export function RelaxedCandidatePanel({
  projectId,
  candidate,
  scheduledLessons,
  requiredLessons,
  accepting,
  replanning,
  notice,
  error,
  onAccept,
  onReplan,
  onClose
}: {
  projectId: string;
  candidate: SchedulingCandidate;
  scheduledLessons: number;
  requiredLessons: number;
  accepting: boolean;
  replanning: boolean;
  notice: string | null;
  error: unknown;
  onAccept: () => void;
  onReplan: () => void;
  onClose: () => void;
}): React.JSX.Element {
  const relaxations = candidate.actual_relaxations ?? [];
  return (
    <>
      <div className="candidate-completion" role="status">
        <strong>已安排全部 {scheduledLessons} / {requiredLessons} 节课程</strong>
        <span>这份课表尚未保存，只有你明确采用后才会写入项目。</span>
      </div>
      <section className="candidate-relaxations" aria-labelledby="relaxation-summary-title">
        <h3 id="relaxation-summary-title">
          本方案实际放宽了 {new Set(relaxations.map((item) => item.condition_key)).size} 项条件
        </h3>
        <ul>
          {relaxations.map((item) => (
            <li key={item.event_id}>
              <strong>{item.message}</strong>
              <span>原要求：{item.original_value}</span>
              <span>实际安排：{item.actual_value}</span>
            </li>
          ))}
        </ul>
      </section>
      {notice ? <p className="warning-note" role="status">{notice}</p> : null}
      {error ? (
        <p className="error-message" role="alert">
          {error instanceof Error ? error.message : "备选课表操作失败，请重试"}
        </p>
      ) : null}
      <details className="candidate-timetable-details" open>
        <summary>查看完整课表</summary>
        <CandidateTimetablePreview projectId={projectId} candidate={candidate} />
      </details>
      <div className="modal-actions candidate-actions">
        <button
          className="secondary-button"
          type="button"
          disabled={accepting || replanning}
          onClick={onClose}
        >
          关闭，稍后再看
        </button>
        <button
          className="secondary-button"
          type="button"
          disabled={accepting || replanning}
          onClick={onReplan}
        >
          {replanning ? "正在寻找其他备选…" : "换一组放宽条件重排"}
        </button>
        <button
          className="primary-button"
          type="button"
          disabled={accepting || replanning}
          onClick={onAccept}
        >
          {accepting ? "正在保存…" : "采用备选并保存"}
        </button>
      </div>
    </>
  );
}
